//the vuex store has been ported to Pinia below. It should be much easier to work with.
//ToDo: payment_app_id has been migrated first from the vuex store to pinia. 
//      if you want to migrate a property simply uncomment from below, remove it from index.ts and change all the usages to read from/write to pinia.

import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

// Your existing object imports
import { booking_group } from "../objects/v1_2/Booking/Booking_Group";
import { booking_search_group } from "../objects/v1_2/Booking_Details/booking_search_group";
import { currency } from "../objects/v1_2/Currency/currency";
import { local_filter } from "../objects/front_end/search/local_filter";
import { product_detail } from "../objects/v1_3/product/product/product_detail";
import { capacity_capacity } from "../objects/v1_3/product/capacity/capacity_capacity";
import { request_login } from "../objects/agent/identity/v1_3/request_login";
import { response_login } from "../objects/agent/identity/v1_3/response_login";
import { response_login_payment } from "../objects/agent/identity/v1_3/response_login_payment";
import { request } from "../objects/v1_2/Booking_Delete/Request/request";
import { filtertag } from "../objects/v1_3/web_engine/filtertag";
import { request_payment_initialise_internal } from "../objects/v1_3/payment/initialise/request_payment_initialise_internal";

import { Passenger_Draft } from "../components/base/4_checkout/passenger_rules";

import { Basket } from "./basket";
import { Booking } from "./booking";
import { Product } from "./product";

const basketEngine = new Basket();
const bookingEngine = new Booking();
const productEngine = new Product();

export const useBookingStore = defineStore('bookingStore', () => {
    
    // ==========================================
    // 📌 STATE (Think: Fields / Auto-Properties)
    // ==========================================
    // const agent_login_info = ref<response_login>(initializeFromStorage("agent_login_info", new response_login()));
    // const agent_login_request = ref<request_login>(new request_login());
    // const selected_capacity = ref<capacity_capacity>(new capacity_capacity());
    // const selected_payment = ref<response_login_payment>(new response_login_payment());
    // const booking_cancelation = ref<request>(new request());
    
    // const filters = ref<local_filter[]>([]);
    // const filter_tags = ref<filtertag[]>([]);
    // const tags = ref<filtertag[]>([]);
    
    // const product_search = ref<string>("");
    // const search_result = ref<string>("");
    const payment_app_id = ref<string>("");
    
    // const payment_full = ref<boolean>(true);
    // const payment_deposit = ref<boolean>(false);
    // const isQuoteCalculating = ref<boolean>(false);

    // Checkout passenger form: input not stored on the passenger itself, keyed by passenger_identifier.
    const passenger_drafts = ref<Record<string, Passenger_Draft>>({});
    // Set once the customer tries to continue, so every missing field is flagged (not only touched ones).
    const show_passenger_errors = ref<boolean>(false);
    const newsletter_opt_in = ref<boolean>(false);
    
    // const payment_attempts = ref<number>(0);
    // const seats_free_selected_date = ref<number>(-1);
    
    // const isPaymentAcknowledgement_timely_checked = ref<boolean | undefined>(undefined);
    // const isPaymentAcknowledgement_transfer_checked = ref<boolean | undefined>(undefined);

    // // Private reactive references for your complex lazy-loaded properties [1]
    // const _booking_basket = ref<booking_group | undefined>(initializeFromStorage("booking_basket"));
    // const _payment_session = ref<request_payment_initialise_internal | undefined>(initializeFromStorage("payment_session"));
    // const _booking_details = ref<booking_search_group | undefined>(initializeFromStorage("booking_details"));
    // const _booking_details_unedited = ref<booking_search_group | undefined>(initializeFromStorage("booking_details_unedited"));
    // const _products = ref<product_detail[] | undefined>(initializeFromStorage("products"));
    // const _currency = ref<currency | undefined>(initializeFromStorage("currency_info"));

    // ==========================================
    // 🔍 GETTERS (Think: Properties with 'get' blocks)
    // ==========================================
    // const booking_basket = computed(() => {
    //     if (!_booking_basket.value) {
    //         _booking_basket.value = basketEngine.Initialise_Basket(new booking_group(), "", 0, "");
    //     }
    //     return _booking_basket.value;
    // });

    // const payment_session = computed(() => {
    //     if (!_payment_session.value) {
    //         _payment_session.value = new request_payment_initialise_internal();
    //     }
    //     return _payment_session.value;
    // });

    // const booking_details = computed(() => _booking_details.value ?? bookingEngine.Blank_Booking());
    // const booking_details_unedited = computed(() => _booking_details_unedited.value ?? bookingEngine.Blank_Booking());
    // const products = computed(() => _products.value ?? []);
    // const current_currency = computed(() => _currency.value ?? new currency());

    // // ==========================================
    // // ⚡ ACTIONS (Think: Methods & Setters)
    // // ==========================================
    // function updateBasketStorage() {
    //     sessionStorage.booking_basket = JSON.stringify(_booking_basket.value);
    // }

    // function Initialise_Basket(Currency: any, Trip_Index: number, Tour_ID: any) {
    //     _booking_basket.value = basketEngine.Initialise_Basket(booking_basket.value, Currency, Trip_Index, Tour_ID);
    //     updateBasketStorage();
    // }

    // function Initialise_Basket_Departure(Trip_Index: number, Departure_Date: any, Capacity: capacity_capacity) {
    //     selected_capacity.value = Capacity;
    //     _booking_basket.value = basketEngine.Initialise_Basket_Departure(booking_basket.value, Trip_Index, Departure_Date) ?? new booking_group();
    //     updateBasketStorage();
    // }

    // function Setup_Booking(bookingDetails: booking_search_group) {
    //     _booking_details.value = bookingDetails;
    //     _booking_details_unedited.value = JSON.parse(JSON.stringify(bookingDetails));
    //     sessionStorage.booking_details = JSON.stringify(bookingDetails);
    //     sessionStorage.booking_details_unedited = JSON.stringify(bookingDetails);
    // }

    // function Set_Agent_Login(agentLogin: response_login, agentRequest: request_login) {
    //     agent_login_info.value = agentLogin;
    //     agent_login_request.value = agentRequest;
    //     sessionStorage.agent_login_info = JSON.stringify(agentLogin);
    // }

    // function Logout_Agent() {
    //     agent_login_request.value = new request_login();
    //     agent_login_info.value = new response_login();

    //     sessionStorage.removeItem("agent_login_info");
    //     sessionStorage.removeItem("booking_basket");
    //     sessionStorage.removeItem("booking_details");
    //     sessionStorage.removeItem("booking_details_unedited");

    //     _booking_basket.value = basketEngine.Initialise_Basket(new booking_group(), "", 0, "");
    //     _booking_details.value = bookingEngine.Blank_Booking();
    //     _booking_details_unedited.value = bookingEngine.Blank_Booking();
    // }

    // function Initialise_Booking_Cancellation() {
    //     booking_cancelation.value = bookingEngine.Create_Cancellation_Object(booking_details.value);
    // }

    // // Helper function to keep code clean and strongly typed
    // function initializeFromStorage(key: string, defaultValue: any = undefined) {
    //     const item = sessionStorage.getItem(key);
    //     if (item && item !== 'undefined') {
    //         try { return JSON.parse(item); } catch { return defaultValue; }
    //     }
    //     return defaultValue;
    // }

    // Export everything cleanly [1]
    return {
        payment_app_id,
        passenger_drafts,
        show_passenger_errors,
        newsletter_opt_in
        // agent_login_info, agent_login_request, selected_capacity, selected_payment, booking_cancelation,
        // filters, filter_tags, tags, product_search, search_result, payment_full,
        // payment_deposit, isQuoteCalculating, payment_attempts, seats_free_selected_date,
        // isPaymentAcknowledgement_timely_checked, isPaymentAcknowledgement_transfer_checked,
        // booking_basket, payment_session, booking_details, booking_details_unedited, products, current_currency,
        // Initialise_Basket, Initialise_Basket_Departure, Setup_Booking, Set_Agent_Login, Logout_Agent, Initialise_Booking_Cancellation
    };
}, {
    persist: {
        storage: sessionStorage,
        pick: ['payment_app_id', 'passenger_drafts', 'newsletter_opt_in'] // Specify which properties to persist (v4 of the plugin uses 'pick'; 'paths' was ignored)
    }}
);
